import React from "react";
import { getFullName } from "../../../careprovider/visits/utils";
import { useGetRole } from "../../../generic/hooks/useGetRole";
import { dateAndTime } from "../../../../utils/dateutils";

const BlockPopoverContent = ({ visit, careplan }) => {
  const role = useGetRole();
  const workforce = careplan?.opportunities?.find(
    (item) => item.id === visit.opportunityId
  )?.workforce;

  return (
    <>
      <div className="px-3">
        {role === "Volunteer Coordinator" && (
          <div>
            By:{" "}
            <span className="font-weight-bold">
              {getFullName(
                visit?.coordinator?.givenName ?? workforce?.givenName,
                visit?.coordinator?.familyName ?? workforce?.familyName
              )}
            </span>
          </div>
        )}
        {role === "Volunteer" && visit?.coordinator && (
          <div>
            By:{" "}
            <span className="font-weight-bold">
              {getFullName(
                visit?.coordinator?.givenName,
                visit?.coordinator?.familyName
              )}
            </span>
          </div>
        )}

        {visit?.createdTimestamp && (
          <div>
            On:{" "}
            <span className="font-weight-bold">
              {dateAndTime(visit?.createdTimestamp)}
            </span>
          </div>
        )}

        <div>
          Status:{" "}
          <span className="font-weight-bold">
            {visit?.status === "Submitted" ? "Pending Approval" : visit?.status}
          </span>
        </div>
      </div>
    </>
  );
};

export default BlockPopoverContent;
